// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2tOGf","clinicsSelect":"TableHeading_clinicsSelect__2i452"};